import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth.ts';
import { RoutingPlans } from 'schemas/RoutingPlan.schema';
import { apiFetch } from 'utils/apiUtils.ts';

interface IFetchTeamRoutingPlansVariables {
  teamId?: string;
  enabled?: boolean;
}

export default function useFetchTeamRoutingPlans({ teamId, enabled = true }: IFetchTeamRoutingPlansVariables) {
  const { tokens } = useAuth();
  return useQuery({
    queryKey: ['teamRoutingPlans', { teamId }],
    queryFn: () => apiFetch<RoutingPlans>({
      path: `team/${teamId}/routing`,
      method: 'GET',
      accessToken: String(tokens.accessToken),
    }),
    enabled: !!teamId && enabled,
  });
}
